import isEmail from 'validator/es/lib/isEmail';
import isNumeric from 'validator/es/lib/isNumeric';
import isEmpty from 'validator/es/lib/isEmpty';
import isMobilePhone from 'validator/es/lib/isMobilePhone';

export default {
  createFieldObject(type, label, defaultValue = '', constraints = {}, options = [], settings = {}) {
    return {
      type,
      label,
      options,
      constraints,
      value: defaultValue,
      error: '',
      disabled: false,
      ...settings,
    };
  },
  makeSelectOptionsFromArray(options) {
    return options.map((value) => ({ value, label: value }));
  },
  makeSelectOptionsFromObject(options) {
    return Object.entries(options).map(([value, label]) => ({ value, label }));
  },
  validate(fields) {
    Object.keys(fields).forEach((fieldName) => {
      this.validateField(fields, fieldName);
    });
  },
  validateField(fields, fieldName) {
    const field = fields[fieldName];

    if (!field) return;

    field.error = '';

    // eslint-disable-next-line
    Object.entries(field.constraints).some(([constraint, options]) => {
      const message = typeof options === 'string' ? options : options.message;
      const valueIsValid = this.constraints[constraint](field.value, options, fields);
      if (!valueIsValid) {
        field.error = message;
        return true; // break;
      }
    });
  },
  constraints: {
    email: (val) => isEmail(val),
    match: (val, options, fields) => val === fields[options.field].value,
    number: (val) => val === '' || isNumeric(val.toString()),
    phone: (val) => isMobilePhone(val.replaceAll(/(^\+7|^8|\D)/g, ''), 'ru-RU'),
    required: (val) => (typeof val === 'boolean') ? val : !isEmpty(val),    // eslint-disable-line
  },
  hasErrors(fields) {
    return Object.values(fields).reduce((acc, curr) => acc || !!curr.error, false);
  },
  getValues(fields) {
    const getCastedValue = (field) => {
      switch (field.type) {
        case 'float':     return field.value === '' ? null : parseFloat(field.value);     // eslint-disable-line
        case 'int':       return field.value === '' ? null : parseInt(field.value, 10);   // eslint-disable-line
        case 'date':      return field.value === '' ? null : field.value;                 // eslint-disable-line
        case 'datetime':  return field.value === '' ? null : field.value;                 // eslint-disable-line
        default:          return field.value;                                             // eslint-disable-line
      }
    };

    return Object.fromEntries(
      Object.entries(fields)
        .map(([name, field]) => [name, getCastedValue(field)]),
    );
  },
  setValues(fields, source) {
    Object.keys(fields).forEach((fieldName) => {
      const field = fields[fieldName];
      const value = source[fieldName];

      if (value) {
        field.value = value;
      }
    });
  },
  clear(fields) {
    Object.keys(fields).forEach((fieldName) => {
      const field = fields[fieldName];
      field.error = '';
      field.value = '';
    });
  },
};
